import { render, staticRenderFns } from "./MenuCouponManageIcon.vue?vue&type=template&id=d1bf1f7a&"
import script from "./MenuCouponManageIcon.vue?vue&type=script&lang=ts&"
export * from "./MenuCouponManageIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports